import { TOOL_WIDGETS, ToolWidgetType, WidgetType } from "../models/widgetType"

export const isToolWidgetType = (type: WidgetType): type is ToolWidgetType => {
  return type in TOOL_WIDGETS
}